module.exports = __webpack_public_path__ + "img/8-1.134042a2.jpg";